import { Phone } from "lucide-react";
import { toast } from "sonner";

import { callMode, dial } from "@/lib/ringoverPhone";

// Lien d'appel : ouvre le téléphone Ringover intégré (ou le lien tel: si ce mode est désactivé)
export function CallLink({ phone, className, children, testid, onCalled }) {
  const onClick = async (e) => {
    if (callMode() !== "embedded") return;
    e.preventDefault();
    try { await dial(phone); onCalled?.(); } catch (err) { toast.error(err.message); }
  };
  return <a href={`tel:${phone}`} className={className} onClick={onClick} data-testid={testid}>{children ?? <><Phone size={14} /> {phone}</>}</a>;
}
